import update from 'immutability-helper';
import defaultEditorState, { livefeedStyle } from 'components/pages/livefeed/defaultstate';
import { setEntityFont, setEmptyEntity, handleOverwriteHistory } from './historyActions'
import { uploadLogo } from '../livefeedapi'
//  Merge data from API
export const MERGE_SLIDES_DATA = 'MERGE_SLIDES_DATA'
export function mergeSlidesData(data) {
    return (dispatch) => {
        dispatch({
            type: MERGE_SLIDES_DATA,
            data
        })
    }
}

export const MERGE_LAYOUT = 'MERGE_LAYOUT'
export function mergeLayout(slideCurrentIndex, payload) {
    return {
        type: MERGE_LAYOUT,
        slideCurrentIndex,
        payload
    }
}

export const SET_LIVEFEED_NAME = 'SET_LIVEFEED_NAME'
export function setLivefeedName(livefeedName) {
    return {
        type: SET_LIVEFEED_NAME,
        livefeedName
    }
}

export const UPDATE_COLOR_PICKER_POS = 'UPDATE_COLOR_PICKER_POS'
export function updateColorPickerPos(pos) {
    return {
        type: UPDATE_COLOR_PICKER_POS,
        pos
    }
}

export const SET_EDITOR_VIEW = 'SET_EDITOR_VIEW'
export function setEditorView(boolean) {
    return {
        type: SET_EDITOR_VIEW,
        boolean
    };
}

// called this function when create new livefeed
export const DEFAULT_STATE = 'DEFAULT_STATE'
export function setEditorDefaultState() {
    return {
        type: DEFAULT_STATE
    }
}

// ------------------------------------Livefeed and Toolbar editor  set function
export const SET_FONT_FAMILY = 'SET_FONT_FAMILY'
export function setFontFamily(slideCurrentIndex, font) {
    return {
        type: SET_FONT_FAMILY,
        slideCurrentIndex,
        font
    }
}

//Logo CRUD
export const SET_LOGO = 'SET_LOGO'
export function setLogo(payload) {
    return {
        type: SET_LOGO,
        payload
    };
}

export const REMOVE_LOGO = 'REMOVE_LOGO'
export function removeLogo(slideCurrentIndex) {
    return {
        type: REMOVE_LOGO,
        slideCurrentIndex
    }
}

export const REMOVE_LOGO_PLACEHOLDER = 'REMOVE_LOGO_PLACEHOLDER'
export function removeLogoPlaceholder(slideCurrentIndex) {
    return {
        type: REMOVE_LOGO_PLACEHOLDER,
        slideCurrentIndex
    }
}
// Line CRUD
export const SET_LINE = 'SET_LINE'
export function setLine(payload) {
    return {
        type: SET_LINE,
        payload
    };
}

export const REMOVE_LINE = 'REMOVE_LINE'
export function removeLine(slideCurrentIndex) {
    return {
        type: REMOVE_LINE,
        slideCurrentIndex
    };
}
// Text CRUD
export const ADD_TEXT = 'ADD_TEXT'
export function addText(payload) {
    return {
        type: ADD_TEXT,
        payload
    };
}

export const REMOVE_TEXT = 'REMOVE_TEXT'
export function removeText(payload) {
    return {
        type: REMOVE_TEXT,
        payload
    };
}

export const SET_TEXT = 'SET_TEXT'
export function setText(payload) {
    return {
        type: SET_TEXT,
        payload
    };
}
// Set Background color
export const SET_SLIDE_BG = 'SET_SLIDE_BG'
export function setSlideBg(payload) {
    return {
        type: SET_SLIDE_BG,
        payload
    };
}

export const SET_LEFT_PANEL_BG = 'SET_LEFT_PANEL_BG'
export function setLeftPanelBg(payload) {
    return {
        type: SET_LEFT_PANEL_BG,
        payload
    };
}

export const SET_RIGHT_PANEL_BG = 'SET_RIGHT_PANEL_BG'
export function setRightPanelBg(payload) {
    return {
        type: SET_RIGHT_PANEL_BG,
        payload
    };
}

// gauge
export const SET_GAUGE = 'SET_GAUGE'
export function setGauge(payload) {
    return {
        type: SET_GAUGE,
        payload
    };
}
// Locations List Style
export const SET_LOCATIONS_LIST_STYLE = 'SET_LOCATIONS_LIST_STYLE'
export function setLocationsListStyle(payload) {
    return {
        type: SET_LOCATIONS_LIST_STYLE,
        payload
    };
}

//Right Panel Text title
export const SET_GAUGE_TITLE = 'SET_GAUGE_TITLE'
export function setGaugleTitle(payload) {
    return {
        type: SET_GAUGE_TITLE,
        payload
    };
}
// Gauge Value Label
export const SET_GAUGE_LABEL = 'SET_GAUGE_LABEL'
export function setGaugeLabel(payload) {
    return {
        type: SET_GAUGE_LABEL,
        payload
    };
}
// Gauge Occupied Background color
export const SET_GAUGE_OCCUPIED_BG = 'SET_GAUGE_OCCUPIED_BG'
export function setGaugeOccupiedBg(payload) {
    return {
        type: SET_GAUGE_OCCUPIED_BG,
        payload
    };
}
// Gauge Offset Background color
export const SET_GAUGE_OFFSET_BG = 'SET_GAUGE_OFFSET_BG'
export function setGaugeOffsetBg(payload) {
    return {
        type: SET_GAUGE_OFFSET_BG,
        payload
    };
}
// Gauge Needle Background color
export const SET_GAUGE_NEEDLE_BG = 'SET_GAUGE_NEEDLE_BG'
export function setGaugeNeedleBg(payload) {
    return {
        type: SET_GAUGE_NEEDLE_BG,
        payload
    };
}

//---------------------------------------------------------thunk action creators switch (Wrapper function ) ----------------------------------------------

/* Update Function ( function start with updateXYZ word will be handled by handleOverwriteHistory
    On the other hand, function call updateXYZ also will be handled )
*/
export function updateEmptyEntity() {
    return handleOverwriteHistory(updateEmptyEntity, setEmptyEntity, false, false)
}
export function updateFontFamily(font) {
    return (dispatch, getState) => {
        const { slideCurrentIndex } = getState().livefeededitor;
        dispatch(setFontFamily(slideCurrentIndex, font))
        let entityFont = {
            slideCurrentIndex: slideCurrentIndex,
            id: null,
            fontFamily: font
        }
        dispatch(updateEntityFont(entityFont))
    }
}
export function updateEntityFont(entity) {
    return handleOverwriteHistory(updateEntityFont, setEntityFont, entity, false)
}
export function updateSlideBg(entity) {
    return handleOverwriteHistory(updateSlideBg, setSlideBg, entity, false)
}
export function updateLeftPanelBg(entity) {
    return handleOverwriteHistory(updateLeftPanelBg, setLeftPanelBg, entity, false)
}
export function updateRightPanelBg(entity) {
    return handleOverwriteHistory(updateRightPanelBg, setRightPanelBg, entity, false)
}

export function updateLogo(entity) {
    return handleOverwriteHistory(updateLogo, setLogo, entity, false)
}
export function addTextBox(entity) {
    return handleOverwriteHistory(addTextBox, addText, entity, false)
}
export function updateLine(entity) {
    return handleOverwriteHistory(updateLine, setLine, entity, false)
}
export function updateText(entity) {
    return handleOverwriteHistory(updateText, setText, entity, false)
}

export function updateGauge(entity) {
    return handleOverwriteHistory(updateGauge, setGauge, entity, false)
}
export function updateLocationsListStyle(entity) {
    return handleOverwriteHistory(updateLocationsListStyle, setLocationsListStyle, entity, false)
}

export function updateGaugleTitle(entity) {
    return handleOverwriteHistory(updateGaugleTitle, setGaugleTitle, entity, false)
}
export function updateGaugeLabel(entity) {
    return handleOverwriteHistory(updateGaugeLabel, setGaugeLabel, entity, false)
}
export function updateGaugeOccupiedBg(entity) {
    return handleOverwriteHistory(updateGaugeOccupiedBg, setGaugeOccupiedBg, entity, false)
}
export function updateGaugeOffsetBg(entity) {
    return handleOverwriteHistory(updateGaugeOffsetBg, setGaugeOffsetBg, entity, false)
}
export function updateGaugeNeedleBg(entity) {
    return handleOverwriteHistory(updateGaugeNeedleBg, setGaugeNeedleBg, entity, false)
}

//------------------------------- toolbar action switch ------------------------------
export function removeEntity(id) {
    return (dispatch, getState) => {
        const { slideCurrentIndex, livefeedSlides } = getState().livefeededitor;
        switch (id) {
            case "logo": {
                const { logoState } = livefeedSlides.slice()[slideCurrentIndex]
                // remove logo or logoplaceholder
                if (logoState.url !== null) {
                    // Call deleteLogo to delete logo from database
                    // dispatch(a.deleteLogo(logoId, slideCurrentIndex))
                    let logoId = logoState.url.split('/').pop()
                    console.log("logoId", logoId)
                    dispatch(removeLogo(slideCurrentIndex))
                    dispatch(removeLogoPlaceholder(slideCurrentIndex))
                } else {
                    console.log("remove logo placeholder")
                    dispatch(removeLogoPlaceholder(slideCurrentIndex))
                }
            }
                break;
            case "line":
                dispatch(removeLine(slideCurrentIndex))
                break;
        }
        let slidePayload = { slideCurrentIndex: slideCurrentIndex, id: id }
        typeof id == 'number' && (dispatch(removeText(slidePayload)));   // if entity is an obj in textContainer arr
        dispatch(updateEmptyEntity());
    }
}
export function addEntity(e, type) {
    return (dispatch, getState) => {
        const { slideCurrentIndex, livefeedSlides } = getState().livefeededitor;;
        const { fontFamily, textContainer } = livefeedSlides[slideCurrentIndex]
        switch (type) {
            case "line": {
                const defaultLine = update(defaultEditorState.livefeedSlides[0].lineState, {
                    slideCurrentIndex: { $set: slideCurrentIndex }
                });
                dispatch(updateLine(defaultLine))
            }
                break;
            case "logo": {
                const defaultLogoPlaceholder = update(defaultEditorState.livefeedSlides[0].logoState, {
                    slideCurrentIndex: { $set: slideCurrentIndex }
                });
                dispatch(updateLogo(defaultLogoPlaceholder))
                var reader = new FileReader();
                var file = e.target.files[0];
                reader.onloadend = () => {
                    dispatch(uploadLogo(file))
                }
                file && reader.readAsDataURL(file);
            }
                break;
            case "textObj": {
                // default
                let newTextObj = update(defaultEditorState.livefeedSlides[0].textContainer[0], {
                    slideCurrentIndex: { $set: slideCurrentIndex },
                    fontFamily: { $set: fontFamily }
                });

                // if textContainer>0 copy first textObj
                if (textContainer.length > 0) {
                    newTextObj = update(textContainer[0], {
                        slideCurrentIndex: { $set: slideCurrentIndex },
                        align: { $set: "left" },
                        width: { $set: 83 },
                        content: { $set: `Text box` },
                        left: { $set: 33 },
                        size: { $set: 20 },
                        top: { $set: 55 },
                        show: { $set: true },
                        activeToolbarItems: {
                            [0]: {
                                align: { $set: "left" }
                            }
                        }
                    });
                }
                dispatch(addTextBox(newTextObj))
            }
                break;
            default:
        }
    }
}
export function alignEntity(entityId, mode) {
    return (dispatch, getState) => {
        const { slideCurrentIndex } = getState().livefeededitor;
        const { slideType, historyEntities } = getState().livefeededitor.livefeedSlides.slice()[slideCurrentIndex];
        const history = historyEntities.slice();
        let currentEntity = history[history.length - 1];
        let livefeedAlignCenter;
        if (slideType === "summary" || slideType === "locationsList") {
            livefeedAlignCenter = livefeedStyle.align.summaryCenter
        } else {
            livefeedAlignCenter = livefeedStyle.align.center
        }
        let livefeedAlignRight;
        if (slideType === "summary" || slideType === "locationsList") {
            livefeedAlignRight = livefeedStyle.align.summaryRight
        } else {
            livefeedAlignRight = livefeedStyle.align.right
        }
        let newLeft; // little hack when using react-rnd
        if (mode === "center") {
            newLeft = currentEntity.id === "line" ? livefeedAlignCenter - currentEntity.length / 2 : livefeedAlignCenter - currentEntity.width / 2
        } else if (mode === "right") {
            newLeft = currentEntity.id === "line" ? livefeedAlignRight - currentEntity.length : livefeedAlignRight - currentEntity.width
        } else if (mode === "left") {
            newLeft = livefeedStyle.align.left;
        }
        const newState = update(currentEntity, {
            left: { $set: newLeft },
            align: { $set: mode },
            activeToolbarItems: { [0]: { align: { $set: mode } } }
        });
        switch (entityId) {
            case "logo":
                dispatch(updateLogo(newState));
                break;
            case "line":
                dispatch(updateLine(newState));
                break;
            case "gauge0":
                dispatch(updateGauge(newState));
                break;
            case "gauge1":
                dispatch(updateGauge(newState));
                break;
            case "gauge2":
                dispatch(updateGauge(newState));
                break;
            case "rightPanelTextTitle":
                dispatch(updateGaugleTitle(newState));
                break;
            case "rightPanelGaugeValueLabel":
                dispatch(updateGaugeLabel(newState));
                break;
            case "locationsListStyle":
                dispatch(updateLocationsListStyle(newState));
                break;
        }
        if (typeof entityId == 'number') {
            if (mode === "right" || mode === "center") {
                newState.left = newState.left + 10 // padding issue
            }
            dispatch(updateText(newState));  // if entity is an obj in textContainer arr
        }
    }
}

export function colorisingEntity(entityId, value) {
    return (dispatch, getState) => {
        const { slideCurrentIndex } = getState().livefeededitor;
        const { historyEntities } = getState().livefeededitor.livefeedSlides.slice()[slideCurrentIndex];
        const history = historyEntities.slice();
        let currentEntity = history[history.length - 1];
        const newState = update(currentEntity, {
            color: { $set: value }
        });
        switch (entityId) {
            case "line":
                dispatch(updateLine(newState));
                break;
            case "slideBg":
                dispatch(updateSlideBg(newState));
                break;
            case "leftPanelBg":
                dispatch(updateLeftPanelBg(newState));
                break;
            case "rightPanelBg":
                dispatch(updateRightPanelBg(newState));
                break;
            case "rightPanelTextTitle":
                dispatch(updateGaugleTitle(newState));
                break;
            case "rightPanelGaugeValueLabel":
                dispatch(updateGaugeLabel(newState));
                break;
            case "rightPanelGaugeOccupiedBg":
                dispatch(updateGaugeOccupiedBg(newState));
                break;
            case "rightPanelGaugeOffsetdBg":
                dispatch(updateGaugeOffsetBg(newState));
                break;
            case "rightPanelGaugeNeedle":
                dispatch(updateGaugeNeedleBg(newState));
                break;
            case "locationsListStyle":
                dispatch(updateLocationsListStyle(newState));
                break;
        }
        typeof entityId == 'number' && dispatch(updateText(newState));   // if entity is an obj in textContainer arr
    }
}

export function stylingText(textStyle) {
    return (dispatch, getState) => {
        const { slideCurrentIndex } = getState().livefeededitor;
        const { historyEntities } = getState().livefeededitor.livefeedSlides.slice()[slideCurrentIndex];
        const history = historyEntities.slice();
        let currentEntity = history[history.length - 1];
        const newState = update(currentEntity, {
            textStyle: { $merge: textStyle },
            activeToolbarItems: { [2]: { $merge: textStyle } }
        });
        switch (currentEntity.id) {
            case "rightPanelTextTitle":
                dispatch(updateGaugleTitle(newState));
                break
            case "rightPanelGaugeValueLabel":
                dispatch(updateGaugeLabel(newState));
                break
            case "locationsListStyle":
                dispatch(updateLocationsListStyle(newState));
                break;
            default:
                dispatch(updateText(newState))
        }

    }
}
export function alignGaugeCards(type, sumPageIndex) {
    return (dispatch, getState) => {
        const { livefeedSlides } = getState().livefeededitor;
        const { gauge0, gauge1, gauge2 } = livefeedSlides[sumPageIndex]
        switch (type) {
            case "all": {
                let newGauge0 = update(gauge0, {
                    top: { $set: defaultEditorState.livefeedSlides[0].gauge0.top },
                    left: { $set: defaultEditorState.livefeedSlides[0].gauge0.left }
                });
                let newGauge1 = update(gauge1, {
                    top: { $set: defaultEditorState.livefeedSlides[0].gauge1.top },
                    left: { $set: defaultEditorState.livefeedSlides[0].gauge1.left }
                });
                let newGauge2 = update(gauge2, {
                    top: { $set: defaultEditorState.livefeedSlides[0].gauge2.top },
                    left: { $set: defaultEditorState.livefeedSlides[0].gauge2.left }
                });
                dispatch(setGauge(newGauge0))
                dispatch(setGauge(newGauge1))
                dispatch(setGauge(newGauge2))
            }
                break;
            case "mr": {
                let newGauge0 = update(gauge0, {
                    top: { $set: defaultEditorState.livefeedSlides[0].gauge0.top },
                    left: { $set: defaultEditorState.livefeedSlides[0].gauge0.left + gauge0.width / 1.5 }
                });
                let newGauge2 = update(gauge2, {
                    top: { $set: defaultEditorState.livefeedSlides[0].gauge2.top },
                    left: { $set: defaultEditorState.livefeedSlides[0].gauge2.left - gauge2.width / 1.5 }
                });
                dispatch(setGauge(newGauge0))
                dispatch(setGauge(newGauge2))
            }
                break;
            case "oa": {
                let newGauge0 = update(gauge0, {
                    top: { $set: defaultEditorState.livefeedSlides[0].gauge0.top },
                    left: { $set: defaultEditorState.livefeedSlides[0].gauge0.left + gauge0.width / 1.5 }
                });
                let newGauge1 = update(gauge1, {
                    top: { $set: defaultEditorState.livefeedSlides[0].gauge1.top },
                    left: { $set: defaultEditorState.livefeedSlides[0].gauge1.left + gauge1.width / 1.5 }
                });
                dispatch(setGauge(newGauge0))
                dispatch(setGauge(newGauge1))
            }
        }

    }
}
// for Textbox only
export function textboxAlignRespond(entity, newWidth) {
    return (dispatch, getState) => {
        const { slideCurrentIndex } = getState().livefeededitor;
        const { slideType } = getState().livefeededitor.livefeedSlides.slice()[slideCurrentIndex];
        let livefeedAlignCenter = slideType === "summary" ? livefeedStyle.align.summaryCenter : livefeedStyle.align.center
        let livefeedAlignRight = slideType === "summary" ? livefeedStyle.align.summaryRight : livefeedStyle.align.right
        let newLeft; // little hack when using react-rnd
        switch (entity.align) {
            case "center":
                newLeft = livefeedAlignCenter - (newWidth - 20) / 2  // padding issue
                break;
            case "right":
                newLeft = livefeedAlignRight - newWidth + 10  // padding issue
                break;
            case "left":
                newLeft = livefeedStyle.align.left;
                break;
        }
        const newState = update(entity, {
            width: { $set: newWidth },
            left: { $set: newLeft !== undefined ? newLeft : entity.left }
        });
        dispatch(setText(newState));
    }
}


// WEBPACK FOOTER //
// ./src/actions/livefeed/index.js